<template>
  <div class="containerWrapper">
      <Dialog :visible="display" :modal="true" :closable="false">
      <template #header>
        <h3>Vill du inaktivera containern?</h3>
      </template>
        <h3>Kommentar</h3>
        <InputText id="comment" type="text" v-model="inActivateComment" style="width:100%" />
      <template #footer>
        <Button label="Avbryt" icon="pi pi-times" @click="onCancel()" class="p-button-danger" />
        <Button label="Spara" icon="pi pi-check" @click="onInactivate()" class="p-button-success" />
      </template>
    </Dialog>
    <Dialog :style="{width: '90vw'}" :visible="displayContainerLog" :modal="true" :closable="false" :contentStyle="{overflow: 'visible'}">
      <template #header>
        <h3>Container {{selectedContainerToDisplay.containerName}}</h3>
      </template>
      <ContainerLogByContainer v-if="selectedContainerToDisplay" style="margin-bottom: 30px" :containerId="selectedContainerToDisplay.containerId"/>
      <template #footer>
        <Button label="Stäng" icon="pi pi-times" @click="onCancelContainerDialog()" class="p-button-danger" />
      </template>
    </Dialog>
    <div class="container details">
      <div class="row dashBoardOrdersWrapper">
        <div class="col-md-12">
          <h2>Containers nuvarande positioner</h2>
          <Dropdown style="width:15rem;margin-bottom:10px" v-model="selectedContainerType" :options="containerTypes" @change="onContainerTypeChange()" optionLabel="label" optionValue="value" placeholder="Filtrera containers.." />
          <!--<Dropdown style="width:15rem;margin-bottom:10px" v-model="selectedPlace" :options="places" @change="filterPlace()" optionLabel="label" optionValue="value" placeholder="Välj plats.." />-->
          <DataTable selectionMode="single" :value="filteredContainers" sortField="containerName" :rowClass="rowClass" :rowHover="true" :sortOrder="1" editMode="row" dataKey="id" :filters="filters" :editingRows.sync="editingRows" @row-edit-init="onRowEditInit" @row-edit-cancel="onRowEditCancel">
            <Column field="containerId" header="Container" :sortable="true">
              <template #body="slotProps">
                {{slotProps.data.containerName}}
                <span v-if="slotProps.data.containerState == 'Inaktiv'">
                  <strong>Inaktiv: </strong>
                  <span>{{slotProps.data.comment.text}}</span>
                </span>
              </template>
            </Column>
            <Column field="userId" header="Chaufför" :sortable="true">
              <template #body="slotProps">
                <Dropdown style="width:100%" v-model="slotProps.data.userId" :options="users" optionLabel="label" optionValue="value" placeholder="" :filter="true" :showClear="true"/>
              </template>
            </Column>
            <Column field="truckId" header="På lastbil" :sortable="true">
               <template #body="slotProps">
                <Dropdown style="width:100%" v-model="slotProps.data.truckId" :options="trucks" optionLabel="label" optionValue="value" placeholder="" :filter="true" :showClear="true"/>
              </template>
            </Column>
            <Column field="currPlaceId" header="Nuvarande plats" filterMatchMode="custom" :filterFunction="filterPlace" :sortable="true">
               <template #body="slotProps">
                <Dropdown style="width:100%" v-model="slotProps.data.currPlaceId" :options="places" optionLabel="label" optionValue="value" placeholder="" :filter="true" :showClear="true"/>
              </template>
              <template #filter>
                <Dropdown style="width:100%" v-model="filters['currPlaceId']" :options="places" optionLabel="label" optionValue="value" placeholder="" :filter="true" :showClear="true"/>
              </template>
            </Column>
            <Column field="fractionId" header="Fraktion" :sortable="true">
               <template #body="slotProps">
                <Dropdown style="width:100%" v-model="slotProps.data.fractionId" :options="fractions" optionLabel="label" optionValue="value" placeholder="" :showClear="true"/>
              </template>
            </Column>
            <Column field="prevFillPlaceId" header="Föregående plats" :sortable="true">
               <template #body="slotProps">
                <Dropdown style="width:100%" v-model="slotProps.data.prevFillPlaceId" :options="places" optionLabel="label" optionValue="value" placeholder="" :filter="true" :showClear="true"/>
              </template>
            </Column>
            <Column field="wash" header="Tvätt" headerStyle="width:5rem" bodyStyle="text-align:center" :sortable="true">
               <template #body="slotProps">
                 <Checkbox v-model="slotProps.data.wash" :binary="true" />
              </template>
            </Column>
            <Column header="Kommentar">
              <template #body="slotProps" >
               <InputText style="width:100%" v-tooltip.top="slotProps.data.comment" v-model="slotProps.data.comment" />
              </template>
            </Column>
            <Column header="Datum" :sortable="true">
              <template #body="slotProps" >
                {{getDate(slotProps.data.updatedAt)}}
              </template>
            </Column>
            <Column headerStyle="width:5rem" bodyStyle="text-align:center">
              <template #body="slotProps" >
                <Button class="p-button-success" title="Spara" @click="onSave(slotProps.data)" icon="pi pi-check" ></Button>
              </template>
            </Column>
            <Column headerStyle="width:5rem" bodyStyle="text-align:center">
              <template #body="slotProps" >
                <Button v-if="slotProps.data.containerState == 'Aktiv'" class="p-button-danger" title="Sätt som inaktiv" @click="onInactivateDialog(slotProps.data)" icon="pi pi-minus-circle" ></Button>
                <Button v-else class="p-button-success" title="Sätt som aktiv" @click="onActivate(slotProps.data)" icon="pi pi-check-circle" ></Button>
              </template>
            </Column>
             <Column headerStyle="width:5rem" bodyStyle="text-align:center">
              <template #body="slotProps" >
                <Button class="" title="Visa log" @click="onRowSelect(slotProps.data)" icon="pi pi-eye" ></Button>
              </template>
            </Column>
          </DataTable>
        </div>
      </div>
    </div>
    <Toast position="bottomright" />
  </div>
</template>
<script>
import DataTable from 'primevue/datatable'
import Dialog from 'primevue/dialog'
import Column from 'primevue/column'
import InputText from 'primevue/inputtext'
import Tooltip from 'primevue/tooltip'
import Dropdown from 'primevue/dropdown'
import Button from 'primevue/button'
import moment from 'moment'
import Checkbox from 'primevue/checkbox'
import Toast from 'primevue/toast'
import CommentCreate from '../Comments/CommentCreate'
import ContainerLogByContainer from '@/components/Activities/ContainerLogByContainer'
export default {
  components: {
    'Toast': Toast,
    DataTable,
    Column,
    InputText,
    Tooltip,
    Dropdown,
    Button,
    moment,
    Dialog,
    CommentCreate,
    Checkbox,
    ContainerLogByContainer
  },
  data () {
    return {
      containerTypes: [],
      filteredContainers: [],
      selectedPlace: [],
      selectedContainerType: '',
      containers: [],
      editingRows: [],
      users: [],
      trucks: [],
      places: [],
      fractions: [],
      selectedContainerToInactivate: {},
      inActivateComment: '',
      filters: {},
      display: false,
      displayContainerLog: false,
      selectedContainerToDisplay: null
    }
  },
  originalRows: null,
  created () {
    this.originalRows = {}
  },
  async mounted () {
    const arrContainerTypes = await this.getContainerTypes()
    this.containerTypes = arrContainerTypes.map((el) => ({label: el.name, value: el.id}))
    this.containerTypes.unshift({label: 'Alla', value: -1})
    this.selectedContainerType = this.containerTypes.find(x => x.value === 14).value
    const dataUsers = await this.getUsers()
    this.users = dataUsers.map((el) => ({label: el.userName, value: el.id}))
    const dataTrucks = await this.getTrucks()
    this.trucks = dataTrucks.map((el) => ({label: el.data.regnbr, value: el.id}))
    const dataPlaces = await this.getPlaces()
    this.places = dataPlaces.map((el) => ({label: el.data.name, value: el.id}))
    const dataFractions = await this.getFractions()
    this.fractions = dataFractions.map((el) => ({label: el.data.name, value: el.id}))
    this.containers = await this.getContainers()
    this.filteredContainers = this.containers
    this.filteredContainers = this.filteredContainers.filter((el) => {
      return el.container.objectDescriptionId === this.selectedContainerType
    })
  },
  methods: {
    filterPlace (value, filter) {
      if (filter === undefined || filter === null || (typeof filter === 'string' && filter.trim() === '')) {
        return true
      }
      if (value === undefined || value === null) {
        return false
      }
      return value.toString() === filter.toString()
    },
    onContainerTypeChange () {
      if (this.selectedContainerType !== -1) {
        this.filteredContainers = this.containers
        this.filteredContainers = this.filteredContainers.filter((el) => {
          return el.container.objectDescriptionId === this.selectedContainerType
        })
      } else {
        this.filteredContainers = this.containers
      }
    },
    onRowSelect (data) {
      this.displayContainerLog = true
      this.selectedContainerToDisplay = data
    },
    async getUsers () {
      let response = await this.$http.get('/api/users/drivers')
      return response.data
    },
    async getContainers () {
      let response = await this.$http.get('/api/containercurrlogs/')
      return response.data
    },
    async getTrucks () {
      let response = await this.$http.get('/api/objectdatas/objectgroupid/2')
      return response.data
    },
    async getPlaces () {
      let response = await this.$http.get('/api/containerorders/getavcs')
      return response.data
    },
    async getContainerTypes () {
      let response = await this.$http.get('/api/objectdescriptions/objectgroupid/7')
      return response.data
    },
    async getFractions () {
      let response = await this.$http.get('/api/objectdatas/objectdescriptionid/22')
      return response.data
    },
    getDate (theDate) {
      let formattedDate = moment(theDate).utc().format('YYYY-MM-DD HH:mm:ss')
      return formattedDate
    },
    rowClass (data) {
      return data.containerState
    },
    onRowEditInit (event) {
      this.originalRows[event.index] = {...this.containers[event.index]}
    },
    onRowEditCancel (event) {
      this.containers[event.index] = this.originalRows[event.index]
    },
    onSave (value) {
      let message = 'Vill spara dina ändringar'
      let options = {
        okText: 'Fortsätt',
        cancelText: 'Stäng'
      }
      this.$dialog.confirm(message, options)
        .then(dialog => {
          let url = '/api/arrcontainerlog'
          delete value['id']
          delete value['createdAt']
          delete value['updatedAt']
          delete value['containerName']
          delete value['selectedUser']
          delete value['selectedCurrPlace']
          delete value['selectedPrevPlace']
          delete value['selectedFraction']
          // delete value['comment']
          delete value['container']

          this.$http
            .post(url, [value])
            .then(response => {
              this.$toast.add({severity: 'success', summary: 'Containerplats sparad', life: 3000})
            })
            .catch(error => console.log(error))
        })
        .catch(function () {
          console.log('Clicked on cancel')
        })
    },
    async onActivate (value) {
      value.containerState = 'Aktiv'
      let response = await this.$http.get('/api/objectdatas/' + value.containerId)
      response.data.data.status = 'Aktiv'

      var url = '/api/objectdatas/' + value.containerId
      this.$http
        .put(url, {
          objectdata: {
            data: response.data.data
          }
        })
        .then(response => {
          this.$toast.add({severity: 'success', summary: 'Container satt som aktiv', life: 3000})
        })
        .catch(error => console.log(error))
    },
    async onInactivate () {
      let value = this.selectedContainerToInactivate
      value.containerState = 'Inaktiv'
      let response = await this.$http.get('/api/objectdatas/' + value.containerId)
      response.data.data.status = 'Inaktiv'
      value.comment.text = this.inActivateComment

      var url = '/api/objectdatas/' + value.containerId
      this.$http
        .put(url, {
          objectdata: {
            data: response.data.data
          }
        })
        .then(response => {
          this.$http
            .post('/api/comments', { comment: {imageId: null, userId: localStorage.getItem('userId'), objectId: value.containerObjectId, text: this.inActivateComment} })
            .then(response => {
              this.display = false
              this.inActivateComment = ''
              this.selectedContainerToInactivate = {}
              this.$toast.add({severity: 'success', summary: 'Container satt som inaktiv', life: 3000})
            })
            .catch(error => console.log(error))
        })
        .catch(error => console.log(error))
    },
    onInactivateDialog (value) {
      this.selectedContainerToInactivate = value
      this.display = true
    },
    onCancel () {
      this.display = false
      this.inActivateComment = ''
      this.selectedContainerToInactivate = {}
    },
    onCancelContainerDialog () {
      this.displayContainerLog = false
      this.selectedContainerToDisplay = null
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Orders/ContainerStates.vue